
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getVehicleInspection = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/VehicleInspections/GetInspection/` + auctionId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getVehicleInspectionTires = (vehicleId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/VehicleInspections/GetTires/` + vehicleId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getVehicleInspectionDamages = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/VehicleInspections/GetDamages/` + auctionId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getVehicleLocation = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/VehicleInspections/GetLocation/` + auctionId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getVehicleInspectionPictures = (auctionId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/VehicleInspections/GetPictures/` + auctionId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const downloadVehicleInspection = (serialNumber, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.get(`${Environment.apiUrl}/VehicleInspections/DownloadVehicleInspection/` + serialNumber,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const deleteVehicleInspectionPicture = (vehicleInspectionPictureId, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.delete(`${Environment.apiUrl}/VehicleInspections/DeletePicture/` + vehicleInspectionPictureId,  headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const updateVehicleInspectionTires = (tirePackage, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/VehicleInspections/UpdateTires`, tirePackage, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const updateVehicleInspectionDamages = (damagePackage, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/VehicleInspections/UpdateDamages`, damagePackage, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const uploadVehicleInspectionPicture = (formData, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				headers = {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Accept': 'application/json',
						'SessionKey': sessionKey,
						'ApplicationId': Environment.applicationId
					}
				}
				resolve( axios.post(`${Environment.apiUrl}/VehicleInspections/UploadPicture`, formData, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const VehicleInspectionsService =
{
	getVehicleInspection,
	getVehicleInspectionTires,
	getVehicleInspectionDamages,
	getVehicleLocation,
	getVehicleInspectionPictures,
	downloadVehicleInspection,
	deleteVehicleInspectionPicture,
	updateVehicleInspectionTires,
	updateVehicleInspectionDamages,
	uploadVehicleInspectionPicture
}

export default VehicleInspectionsService
